<template>
  <div class="account-subscription">
    <div class="account-subscription__header">
      <h1 class="account-subscription__title">{{ $tAccountSubscription('My subscription') }}</h1>

      <div class="account-subscription__state relative">
        <BasePreloader v-if="loadingTopUpBalance || loading.accountBalance" class="_white" />

        <div class="account-subscription__state-block">
          <BaseSvg
            name="ico-wallet-outline"
            width="3.1rem"
            height="2.6rem"
            class="account-subscription__state-wallet-icon"
          />
          <div class="account-subscription__state-title">{{ $tAccountSubscription('state_of_account') }}</div>
        </div>
        <div class="account-subscription__state-block">
          <div class="account-subscription__state-count">
            <span>{{ balance.balance }} </span>
            <span class="account-subscription__state-count-currency">{{ balance.currency }}</span>
          </div>
          <button
            class="account-subscription__state-replenish base-btn base-btn--blue base-btn--small"
            @click="onBalanceTopUp"
          >
            <span>{{ $tAccountSubscription('top_up') }}</span>
            <BaseSvg name="ico-plus" width="1.2rem" height="1.2rem" />
          </button>
        </div>
      </div>
    </div>

    <SubpagesTabs :routes="tabsRoutes">
      <transition
        name="fade"
        mode="out-in"
      >
        <router-view />
      </transition>
    </SubpagesTabs>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { isProductionDomain } from '../../../helpers/isProduction';
import SubpagesTabs from '../../../components/SubpagesTabs'

export default {
  name: 'AccountSubscription',
  components: {
    SubpagesTabs,
  },
  data() {
    return {
      loadingTopUpBalance: false,
    };
  },
  computed: {
    ...mapGetters('accountSubscription', [
      'loading',
      'balance',
    ]),

    tabsRoutes() {
      return [
        {
          id: 0,
          name: this.$tAccountSubscription('balance'),
          route: { name: 'account-subscription-balance' },
        },
        // { // TODO temporary hide
        //   id: 1,
        //   name: this.$tAccountSubscription('tariff_plan'),
        //   route: { name: 'account-subscription-tariff' },
        // },
      ]
    },
  },
  created() {
    this.loadAccountBalance();
    this.subscriberOnUpdate();
  },
  beforeDestroy() {
    this.unSubscribeOnUpdate();
  },
  methods: {
    ...mapActions('account/subscription', [
      'getTopUpToken',
      'payWithPopup',
    ]),
    ...mapActions('accountSubscription', [
      'loadAccountBalance',
    ]),

    onBalanceTopUp() {
      this.$vModal.open('select-price', {
        onSubmit: this.onPriceSubmit,
      });
    },
    async onPriceSubmit({ price }) {
      this.loadingTopUpBalance = true;

      const paymentPublicId = await this.getTopUpToken({ price });
      if (paymentPublicId) {
        const mode = isProductionDomain() ? 'prod' : 'sandbox';
        this.payWithPopup({ paymentPublicId, mode });
      }

      this.loadingTopUpBalance = false;
    },

    subscriberOnUpdate() {
      this.$store.dispatch('user/userPusher/createPusher');
      this.unSubscribeOnUpdate();

      this.$store.state.user.userPusher.channel?.bind('update-employer-balance', () => {
        this.loadAccountBalance();
      });
    },
    unSubscribeOnUpdate() {
      this.$store.state.user.userPusher.channel?.unbind('update-employer-balance');
    },
  },
};
</script>
